import services from '@/services';

export const name = 'global-clicks';
export default {
  mounted: (el, binding) => {
    if (binding.value.enabled) {
      addClickListener(el, binding);
    }
  },
  unmounted: el => {
    removeClickListener(el);
  },
  updated: (el, binding) => {
    if (binding.oldValue.enabled !== binding.value.enabled) {
      if (binding.value.enabled) {
        addClickListener(el, binding);
      } else {
        removeClickListener(el);
      }
    }
  },
};

// Use a map to track listeners by element (maps are more deterministic for element keys)
const listeners = new Map();

function addClickListener(el, binding) {
  if (listeners.get(el)) {
  // Already listening (could have happened if enabled flag added after insertion)
  return;
  }

  let listener = globalClickListener.bind(null, el, binding);
  listeners.set(el, listener);
  services.document.addEventListener('click', listener, true);
}

function removeClickListener(el) {
  let listener = listeners.get(el);
  if (listener) {
    services.document.removeEventListener('click', listener, true);
    listeners.delete(el);
  }
}

function globalClickListener(el, binding, event) {
  let elements = [el];
  if (binding.value.selector) {
    elements = services.document.querySelectorAll(binding.value.selector);
  }

  // Change NodeList to Array to use some()
  elements = Array.prototype.slice.call(elements);
  let containsClick = elements.some(element => {
    return element.contains(event.target);
  });

  if (containsClick && binding.value.inside) {
    binding.value.inside();
  } else if (!containsClick && binding.value.outside) {
    binding.value.outside();
  }
}
